const refreshReportSelect2 = () => {
  if (typeof window.initializeManagerAndFundSelects === 'function') {
    window.initializeManagerAndFundSelects('#ticket_form, #proposal_form');
  }

  if (typeof window.initializePassiveMonitorFundSelects === 'function') {
    window.initializePassiveMonitorFundSelects('#ticket_form');
  }

  if (typeof window.initProposalTitleTypeMultiselect === 'function') {
    window.initProposalTitleTypeMultiselect();
  }
};

$(document).ready(function () {
  hideAll();
});

$(document).on('change', '#kind_cd', function () {
  if ($('#kind_cd').val() == 'ticket') {
    $('#ticket_form').show();
    refreshReportSelect2();
  } else {
    $('#ticket_form').hide();
  }

  if ($('#kind_cd').val() == 'transfer') {
    $('#transfer_form').show();
  } else {
    $('#transfer_form').hide();
  }

  if ($('#kind_cd').val() == 'proposal') {
    $('#proposal_form').show();
    refreshReportSelect2();
  } else {
    $('#proposal_form').hide();
  }
});

function hideAll() {
  $('#transfer_form').hide();
  $('#ticket_form').hide();
  $('#proposal_form').hide();
}

window.refreshReportSelect2 = refreshReportSelect2;
